import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { CalendarYearApi, CalendarYearDto, CalendarYearSearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { EditButton, SearchTablePage, ViewButton } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { useGlobalData } from "../../../../contexts";
export interface ICalendarYearListPageProps {}

export const CalendarYearListPage: React.FunctionComponent<ICalendarYearListPageProps> = (props) => {
  const calendarYearApi = useApiService(CalendarYearApi);
  const { t } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();
  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: CalendarYearDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.calendarYear}/${row.calendarYearId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.calendarYear}/${row.calendarYearId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Year),
        fieldName: "year",
      },
      {
        header: () => t(ETLCodes.NamingLetter),
        fieldName: "namingLetter",
      },
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.calendarYear}/0/detail/edit`);
  }, [history]);
  const search = React.useCallback(
    (sObj) =>
      calendarYearApi.baseSearch(CalendarYearSearch.fromJS({ ...sObj, languageCode: currentLanguage.languageCode })),
    [calendarYearApi, currentLanguage.languageCode]
  );

  return (
    <SearchTablePage
      columns={columns}
      searchFunction={search}
      exportFunction={(sObj) =>
        calendarYearApi.exportXlsFile(
          CalendarYearSearch.fromJS({ ...sObj, languageCode: currentLanguage.languageCode })
        )
      }
      addFunc={addItemFunction}
      sortKeys={{ year: "DESC" }}
      breadCrumbs={[{ text: t(ETLCodes.CalendarYears) }]}
    />
  );
};
